import React, { useState } from 'react';
import Icon from '@mdi/react';
import i18next from 'i18next';
import { Box, IconButton, Link, Menu, MenuItem } from '@mui/material';
import {
    mdiCounter,
    mdiHelpCircle,
    mdiHelpCircleOutline,
    mdiInformation,
    mdiSchool,
} from '@mdi/js';

export default () => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);

    const options = {
        about: {
            link: {
                en: 'https://app.storylane.io/share/zyulgruj3dbj',
                de: 'https://app.storylane.io/share/zyulgruj3dbj',
            },
            icon: mdiInformation,
            translation: i18next.t('helpControl.about'),
        },
        tpAcademy: {
            link: {
                en: 'https://customer.academy.thinkproject.com/',
                de: 'https://customer.academy.thinkproject.com/',
            },
            icon: mdiSchool,
            translation: i18next.t('helpControl.tpAcademy'),
        },
        helpCenter: {
            link: {
                en: 'https://help.thinkproject.com/public/en/Content/LandingPages/CDI.htm',
                de: 'https://help.thinkproject.com/public/de/Content/LandingPages/CDI.htm',
            },
            icon: mdiHelpCircle,
            translation: i18next.t('helpControl.helpCenter'),
        },
        versionNumber: {
            link: {
                en: 'https://help.thinkproject.com/public/de/Content/CDI/CDI%20Release%20Notes/pdf-viewer-release-notes.htm',
                de: 'https://help.thinkproject.com/public/de/Content/CDI/CDI%20Release%20Notes/pdf-viewer-release-notes.htm',
            },
            icon: mdiCounter,
            translation: i18next.t('helpControl.versionNumber', { version: '1.11' }),
        },
    };

    return (
        <>
            <IconButton
                title={i18next.t('header.help')}
                onClick={e => setAnchorEl(e.currentTarget)}
            >
                <Icon path={mdiHelpCircleOutline} size={1} />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(undefined)}
                onClick={() => setAnchorEl(undefined)}
            >
                {Object.keys(options).map(key => {
                    const option = options[key];
                    return (
                        <MenuItem
                            component={Link}
                            href={option.link[i18next.language] ?? option.link.en}
                            key={key}
                            underline="none"
                            target="_blank"
                        >
                            <Icon path={option.icon} size={1} />
                            <Box sx={{ ml: 1.5 }}>{option.translation}</Box>
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};
